export default __webpack_public_path__ + "static/media/H4002.c6bec4cf.mp3";